import { store, userManager } from '~/utility/BinSentry-ui-utility';
import { html, LitEntity, renderIf } from '../utility/lit-entity';
import { sharedStyles } from '../styles/shared-styles';
import { sessionStyles } from '../styles/session-styles';
import '../common/bn-logo';
import { StoreMixin } from '../utility/store-mixin';
import '../common/bn-loading';
import '../common/bn-action';
import '../common/bn-flash';
import './confirm-registration-action';

class UserConfirmationPage extends StoreMixin(LitEntity) {
  constructor() {
    super();
    this._stateChanged(store.getState());
  }

  static get properties() {
    return {
      error: { type: String, attribute: false },
      registrationSuccessful: { type: Boolean, attribute: false },
      userIsAuthenticated: { type: Boolean, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, sessionStyles];
  }

  render() {
    return html`
      <div class="boxes">
        <div class="box">
          <bn-logo></bn-logo>
          ${this._renderContents()}
        </div>
      </div>
    `;
  }

  _renderContents() {
    if (this.error) {
      return html`
        <bn-flash id="flash" .banners="${[{ content: this.error, type: 'critical' }]}"></bn-flash>
        <div>
          <a href="/login">Return to sign-in</a>
        </div>
      `;
    }

    if (!this.entity || this.userIsAuthenticated === undefined) {
      return html`
        <bn-loading></bn-loading>`;
    }

    if (this.registrationSuccessful) {
      return html`
        <p>
          Account is created!
        </p>
        <div>
          <a href="${this.userIsAuthenticated ? '/logout' : '/login'}">Sign-in</a>
        </div>
      `;
    }

    return html`
      ${renderIf(this.entity.getAction('confirm-registration'), html`
        <confirm-registration-action .href="${this.href}" @response="${this._onConfirmRegistrationResponse}"></confirm-registration-action>
      `)}
    `;
  }

  _onConfirmRegistrationResponse() {
    this.registrationSuccessful = true;
  }

  _stateChanged({ query }) {
    const reportError = () => {
      this.error = 'Invalid confirmation link';
    };

    if (!query || !query.confirmationUri) {
      return reportError();
    }
    try {
      const url = new URL(query.confirmationUri);
      if (!url.hostname.match(/^api.*binsentry.com$/) || !url.pathname.startsWith('/users/confirmations/')) {
        return reportError();
      }
    } catch (e) {
      return reportError();
    }
    this.href = query.confirmationUri;
  }

  async _entityChanged(entity, error) {
    super._entityChanged(entity, error);

    if (error) {
      this.error = error;
    }
  }

  connectedCallback() {
    super.connectedCallback();
    userManager.currentUser().then(user => {
      this.userIsAuthenticated = !!user;
    });
  }
}

window.customElements.define('user-confirmation-page', UserConfirmationPage);
